import React from 'react';
import CompanyTerms from 'views/CompanyTerms';

const CompanyTermsPage = () => {
  return <CompanyTerms />;
};

export default CompanyTermsPage;